import historyProvider from './historyProvider'
import stream from './stream'



const supportedResolutions = ["1", "2", "5", "15", "30", "60", "120", "240", "D"]

const config = {
    supported_resolutions: supportedResolutions
}; 

export default {
	onReady: cb => {
	console.log('=====onReady running')	
		setTimeout(() => cb(config), 0)
		
	},
	searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
		console.log('====Search Symbols running')
	},
	resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
		// expects a symbolInfo object in response
		console.log('======resolveSymbol running')
		// console.log('resolveSymbol:',{symbolName})
		
		// 심볼 이름 중복 제거 (PEPPERSTONE:PEPPERSTONE:XAUUSD/1 -> PEPPERSTONE:XAUUSD/1)
		var normalizedSymbolName = symbolName
		var split_data = symbolName.split(/[:/]/)
		
		// 중복된 exchange 이름이 있는지 확인 (예: PEPPERSTONE:PEPPERSTONE:XAUUSD/1)
		if (split_data.length >= 3 && split_data[0] === split_data[1]) {
			// 중복 제거: 첫 번째 PEPPERSTONE 제거
			normalizedSymbolName = split_data.slice(1).join(':')
			split_data = normalizedSymbolName.split(/[:/]/)
			console.log('중복 심볼 이름 정규화: ' + symbolName + ' -> ' + normalizedSymbolName)
		}
		
		console.log('symbolName = ' + symbolName + ' (정규화: ' + normalizedSymbolName + ')')
		
		var symbol_stub = {
			name: normalizedSymbolName,  // 정규화된 이름 사용
			description: '',
			type: 'crypto',
			session: '24x7',
			timezone: 'Etc/UTC',
			ticker: normalizedSymbolName,  // 정규화된 이름 사용
			exchange: 'PEPPERSTONE',
			minmov: 1,
			pricescale: 100,
			has_intraday: true,
			intraday_multipliers: ['1', '60'],
			supported_resolution:  supportedResolutions,
			volume_precision: 8,
			data_status: 'streaming',
		}

		if (split_data.length >= 3 && split_data[2].match(/USD|EUR|JPY|AUD|GBP|KRW|CNY|SMI/)) {
			symbol_stub.pricescale = 100
		}
		setTimeout(function() {
			onSymbolResolvedCallback(symbol_stub)
			console.log('Resolving that symbol....', symbol_stub)
		}, 0)
		
		
		// onResolveErrorCallback('Not feeling it today')

	},
	getBars: function(symbolInfo, resolution, from, to, onHistoryCallback, onErrorCallback, firstDataRequest) {
		console.log('=====getBars running')
		// console.log('function args',arguments)
		// console.log(`Requesting bars between ${new Date(from * 1000).toISOString()} and ${new Date(to * 1000).toISOString()}`)
		historyProvider.getBars(symbolInfo, resolution, from, to, firstDataRequest)
		.then(bars => {
			if (bars.length) {
				onHistoryCallback(bars, {noData: false})
			} else {
				onHistoryCallback(bars, {noData: true})
			}
		}).catch(err => {
			console.log({err})
			onErrorCallback(err)
		})

	},
	subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback) => {
		console.log('=====subscribeBars runnning')

		stream.subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback)
	},
	unsubscribeBars: subscriberUID => {
		console.log('=====unsubscribeBars running')

		stream.unsubscribeBars(subscriberUID)
	},
	calculateHistoryDepth: (resolution, resolutionBack, intervalBack) => {
		//optional
		console.log('=====calculateHistoryDepth running')
		// while optional, this makes sure we request 24 hours of minute data at a time
		// CryptoCompare's minute data endpoint will throw an error if we request data beyond 7 days in the past, and return no data
		return resolution < 60 ? {resolutionBack: 'D', intervalBack: '1'} : undefined
	},
	getMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
		//optional
		console.log('=====getMarks running')
	},
	getTimeScaleMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
		//optional
		console.log('=====getTimeScaleMarks running')
	},
	getServerTime: cb => {
		console.log('=====getServerTime running')
	}
}



// WEBPACK FOOTER //
// ./src/components/TVChartContainer/api/index.js